













































































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { HistoryViewMixin, LibraryMixin } from '../../mixins'
import { RawLocation } from 'vue-router'
import { Track } from '../../classes/track'
import { TrackSelectWizardTargets } from '../../store/modules/trackselectwizard'
import { IColumnDef } from '../../interfaces/ag-grid'
import { TrackFields } from '../../constants'

enum VIEWS {
  Start = 'start',
  AllTracks = 'all_tracks',
  SearchFilter = 'search_filter',
  Playlists = 'playlists',
  RecentlyAdded = 'recently_added'
}

@Component({
  components: {
    IconCard: require('@/components/IconCard').default,
    SearchFilter: require('./SearchFilter').default,
    Playlists: require('./Playlists').default,
    RecentlyAdded: require('./RecentlyAdded').default,
    ReorderTable: require('@/components/ReorderTable').default
  }
})
export default class TrackSelectWizard extends Mixins(HistoryViewMixin, LibraryMixin) {
  @Prop({
    required: false
  })
  to: RawLocation

  @Prop({
    required: true
  })
  target: TrackSelectWizardTargets

  @Prop()
  confirmLabel: string

  @Prop()
  introText: string

  @Prop({
    default: false
  })
  showBackButton: boolean

  @Prop({
    default: false
  })
  showFieldEditButton: boolean

  @Prop({
    default: false
  })
  showDeleteButton: boolean

  selectedTracks: Track[] = []
  columnDefs: IColumnDef[] = [
    {
      field: TrackFields.Title,
      rowDrag: true
    },
    {
      field: TrackFields.Artist
    }
  ]

  view: VIEWS = VIEWS.Start

  async confirm(tracks: Track[]) {
    if (this.view === VIEWS.AllTracks) {
      this.$store.commit('library/setSelectedTracksByTrack', this.selectedTracks)
    } else {
      this.$store.commit('library/setSelectedTracksByTrack', tracks)
    }

    this.$emit('confirm')

    if (this.to) {
      await this.$router.push(this.to)
    }
  }

  created() {
    this.$store.commit('library/clearSelectedTracks')
  }
}
